import { render, staticRenderFns } from "./PyRuntimeCom.vue?vue&type=template&id=62cdb084&scoped=true&"
import script from "./PyRuntimeCom.vue?vue&type=script&lang=js&"
export * from "./PyRuntimeCom.vue?vue&type=script&lang=js&"
import style0 from "./PyRuntimeCom.vue?vue&type=style&index=0&id=62cdb084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cdb084",
  null
  
)

export default component.exports